<template>
    <div>
        <b-card class="mt-2 request-short-card" header-class="p-2">
            <span class="request-short-card__accent" :class="cardBorderVariantClass" aria-hidden="true"></span>
            <template #header>
                <b-row :id="request.id">
                    <!-- Левая часть: ключевые поля -->
                    <b-col sm="12" md="5" class="mb-1 mb-md-2">
                        <div class="d-flex align-items-start justify-content-between w-100">
                            <span class="small">№: <b>{{ request.request_number }}</b></span>
                            <!-- Кнопка копирования для мобильных -->
                            <b-button
                                variant="outline-secondary"
                                size="sm"
                                class="p-1 copy-mobile"
                                @click="handleCopy"
                                aria-label="Копировать"
                                title="Копировать"
                            >
                                <i class="fas fa-copy"></i>
                            </b-button>
                        </div>
                        <div v-if="requestTitle">
                            <span class="small">
                                Название: <b>
                                    <a href="" @click.prevent="viewDetails()">{{ requestTitle }}</a>
                                </b>
                            </span>
                        </div>
                        <b-badge v-if="request.workflow_data && request.workflow_data.recurrence" variant="info" class="mr-1">
                            {{ request.workflow_data.recurrence.kind === 'template' ? 'Серия заявок' : 'Повторение серии' }}
                        </b-badge>
                        <!-- Бейджи статуса и сроков — всегда видимы -->
                        <div class="badges-row d-flex flex-wrap" style="gap:.25rem; margin-top:.2rem;">
                            <RequestBadge
                                v-for="badge in requestBadges"
                                :key="badge.key"
                                :badge="badge"
                            />
                        </div>
                        <div v-if="request.fulfillment_review" class="small mt-2">
                            <b-badge variant="warning">Требует разбора</b-badge>
                            <div v-if="request.fulfillment_review.action === 'claim'">
                                <a href="" @click.prevent="viewDetails()">Нужно решить вопрос</a>
                            </div>
                            <div v-else-if="request.fulfillment_review.action === 'resolve'">
                                <a href="" @click.prevent="viewDetails()">Ждёт вашего решения</a>
                            </div>
                            <div v-else class="text-muted">Вопрос решает ответственный</div>
                            <div>{{ request.fulfillment_review.reason }}</div>
                        </div>
                        <div v-if="stageDurationText" class="request-stage-duration" :title="stageDurationTitle">
                            <i class="fas fa-clock" aria-hidden="true"></i>
                            <span>{{ stageDurationText }}</span>
                        </div>
                        <div v-if="hasComments" class="request-comment-row">
                            <button
                                type="button"
                                class="request-comment-indicator"
                                :class="commentIndicatorClass"
                                :title="commentIndicatorTitle"
                                :aria-label="commentIndicatorTitle"
                                @click="viewDetails"
                            >
                                <i class="fas fa-comments" aria-hidden="true"></i>
                                <span>{{ commentsCountText }}</span>
                                <span v-if="newCommentsCount > 0" class="request-comment-indicator__new">
                                    <span class="request-comment-indicator__separator">·</span>
                                    {{ newCommentsCountText }}
                                </span>
                            </button>
                        </div>
                    </b-col>

                    <!-- Вторичные поля: на десктопе — всегда, на мобиле — в collapse -->
                    <b-col sm="12" md="4" class="mb-1 mb-md-2">
                        <div class="d-md-none">
                            <div class="small">
                                <span class="text-muted">Инициатор:</span>
                                <b>
                                    <TelegramUserLink :user="request.Initiator" />
                                </b>
                            </div>
                            <div v-if="request.building_object_name" class="small"><span class="text-muted">Объект:</span> <b>{{ request.building_object_name }}</b></div>
                            <div class="small">
                                <span class="text-muted">Создана:</span>
                                <b>{{ formatDate(request.created_at) }}</b>
                            </div>
                            <div v-if="request.deadline" class="small">
                                <span class="text-muted">Срок до:</span>
                                <b>{{ formatDate(request.deadline) }}</b>
                            </div>
                            <div class="small">
                                <span class="text-muted">Тип:</span>
                                <i class="request-short-inline-icon" :class="requestTypeIcon"></i>
                                <b>{{ request.RequestType ? request.RequestType.name : 'Не указан' }}</b>
                            </div>
                        </div>
                        <!-- Мобильный toggle-раскрытие -->
                        <!-- <a
                            href=""
                            class="d-md-none small text-muted details-toggle"
                            @click.prevent="detailsOpen = !detailsOpen"
                            :aria-expanded="detailsOpen ? 'true' : 'false'"
                        >
                            {{ detailsOpen ? 'Скрыть детали ▲' : 'Детали ▼' }}
                        </a>

                        <b-collapse v-model="detailsOpen" class="d-md-none mt-1">                           
                                                        
                           
                        </b-collapse> -->

                        <!-- Десктоп: всегда развёрнуто -->
                        <div class="d-none d-md-block">
                            <div class="small">
                                <span class="text-muted">Инициатор:</span>
                                <b>
                                    <TelegramUserLink :user="request.Initiator" />
                                </b>
                            </div>
                            <div class="small">
                                <span class="text-muted">Тип:</span>
                                <i class="request-short-inline-icon" :class="requestTypeIcon"></i>
                                <b>{{ request.RequestType ? request.RequestType.name : 'Не указан' }}</b>
                            </div>
                            <div v-if="request.building_object_name" class="small"><span class="text-muted">Объект:</span> <b>{{ request.building_object_name }}</b></div>
                            <div class="small">
                                <span class="text-muted">Создана:</span>
                                <b>{{ formatDate(request.created_at) }}</b>
                                <span v-if="createdElapsedText" class="request-short-relative">
                                    · {{ createdElapsedText }}
                                </span>
                            </div>
                            <div v-if="request.deadline" class="small">
                                <span class="text-muted">Срок до:</span>
                                <b>{{ formatDate(request.deadline) }}</b>
                                <span v-if="deadlineRelativeText" class="request-short-relative">
                                    · {{ deadlineRelativeText }}
                                </span>
                            </div>
                        </div>
                    </b-col>

                    <!-- Кнопка копирования для десктопа -->
                    <b-col sm="12" md="3" class="text-md-right copy-desktop">
                        <b-button variant="outline-secondary" size="sm" @click="handleCopy">
                            <i class="fas fa-copy"></i>
                            <span>Копировать</span>
                        </b-button>
                    </b-col>
                </b-row>
            </template>

            <div class="card-body-content">
                <!-- Описание: на мобиле — 2 строки с раскрытием -->
                <div
                    class="description-wrap mb-2"
                    :class="{ 'description-clamped': !descExpanded && isMobile }"
                    @click="isMobile && (descExpanded = !descExpanded)"
                    :role="isMobile ? 'button' : null"
                    :title="isMobile && !descExpanded ? 'Нажмите, чтобы развернуть' : null"
                >
                    <div v-if="isEmployeeCatalogRequest">
                        <div class="small text-muted mb-1">Сотрудники:</div>
                        <p class="mb-0 font-weight-bold">{{ employeeListText }}</p>
                    </div>
                    <div v-else-if="hasRequestDescription">
                        <p
                            class="mb-0 request-short-description-text"
                            v-html="formatLinkedText(requestDescriptionText)"
                        ></p>
                    </div>
                    <div v-else-if="customFieldsSummary">
                        <div class="small text-muted mb-1">Поля заявки:</div>
                        <p
                            class="mb-0 request-short-description-text request-short-description-text--custom-fields"
                            v-html="formatLinkedText(customFieldsSummary)"
                        ></p>
                    </div>
                    <p
                        v-else
                        class="mb-0 request-short-description-text"
                        v-html="formatLinkedText('Описание не указано')"
                    ></p>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <a
                        v-if="isMobile && descriptionToggleText && descriptionToggleText.length > 80"
                        href=""
                        class="small text-muted desc-toggle"
                        @click.prevent="descExpanded = !descExpanded"
                    >
                        {{ descExpanded ? 'Свернуть ▲' : 'Показать полностью ▼' }}
                    </a>
                    <span v-else></span>
                    <div class="request-short-actions">
                        <b-button
                            v-if="itemsPreviewEnabled"
                            variant="outline-secondary"
                            size="sm"
                            class="request-short-icon-button"
                            :pressed="itemsPreviewOpen"
                            :disabled="itemsPreviewLoading"
                            :title="itemsPreviewOpen ? 'Скрыть позиции' : 'Показать позиции'"
                            :aria-label="itemsPreviewOpen ? 'Скрыть позиции заявки' : 'Показать позиции заявки'"
                            @click="toggleItemsPreview"
                        >
                            <b-spinner v-if="itemsPreviewLoading" small></b-spinner>
                            <i v-else class="fas" :class="itemsPreviewOpen ? 'fa-chevron-up' : 'fa-list-ul'"></i>
                        </b-button>
                        <b-button
                            v-if="requiredAttachmentsPreviewEnabled"
                            variant="outline-secondary"
                            size="sm"
                            class="request-short-icon-button"
                            :pressed="requiredAttachmentsPreviewOpen"
                            :disabled="requiredAttachmentsPreviewLoading"
                            :title="requiredAttachmentsPreviewOpen ? 'Скрыть документы' : 'Показать обязательные документы'"
                            :aria-label="requiredAttachmentsPreviewOpen ? 'Скрыть обязательные документы заявки' : 'Показать обязательные документы заявки'"
                            @click="toggleRequiredAttachmentsPreview"
                        >
                            <b-spinner v-if="requiredAttachmentsPreviewLoading" small></b-spinner>
                            <i v-else class="fas" :class="requiredAttachmentsPreviewOpen ? 'fa-chevron-up' : 'fa-paperclip'"></i>
                        </b-button>
                        <b-button
                            variant="outline-primary"
                            size="sm"
                            @click="viewDetails"
                        >
                            <i class="fas fa-eye"></i>
                            <span class="ml-1">Подробнее</span>
                        </b-button>
                    </div>
                </div>

                <b-collapse
                    v-if="itemsPreviewEnabled"
                    v-model="itemsPreviewOpen"
                    class="mt-2"
                >
                    <div class="request-short-items-preview">
                        <div v-if="itemsPreviewLoading" class="text-center py-2">
                            <b-spinner small label="Загрузка позиций"></b-spinner>
                        </div>
                        <div v-else-if="itemsPreviewError" class="small text-danger py-2">
                            {{ itemsPreviewError }}
                        </div>
                        <div v-else-if="!itemsPreviewItems.length" class="small text-muted py-2">
                            Позиции не добавлены
                        </div>
                        <b-table
                            v-else
                            :items="itemsPreviewRows"
                            :fields="itemsPreviewFields"
                            small
                            striped
                            responsive="sm"
                            borderless
                            class="request-short-items-table mb-0"
                            thead-class="request-short-items-table__head"
                        >
                            <template #cell(index)="{ item }">
                                <span class="text-muted">{{ item.index }}</span>
                            </template>
                            <template #cell(item_name)="{ item }">
                                <div class="request-short-items-table__name">
                                    <strong>{{ item.item_name }}</strong>
                                    <small v-if="item.ppe_data" class="d-block" style="white-space: pre-line">{{ ppeText(item.ppe_data) }}</small>
                                    <small
                                        v-if="item.notes"
                                        class="d-block text-muted request-short-items-table__notes"
                                        v-html="formatLinkedText(item.notes)"
                                    ></small>
                                </div>
                            </template>
                            <template #cell(quantity_text)="{ item }">
                                <span>{{ item.quantity_text }}</span>
                            </template>
                            <template #cell(progress_text)="{ item }">
                                <span>{{ item.progress_text }}</span>
                            </template>
                            <template #cell(executor_text)="{ item }">
                                <EmployeeLink :user="item.executor" :fallback="item.executor_text" compact />
                            </template>
                        </b-table>
                    </div>
                </b-collapse>

                <b-collapse
                    v-if="requiredAttachmentsPreviewEnabled"
                    v-model="requiredAttachmentsPreviewOpen"
                    class="mt-2"
                >
                    <div class="request-short-required-attachments-preview">
                        <div v-if="requiredAttachmentsPreviewLoading" class="text-center py-2">
                            <b-spinner small label="Загрузка документов"></b-spinner>
                        </div>
                        <div v-else-if="requiredAttachmentsPreviewError" class="small text-danger py-2">
                            {{ requiredAttachmentsPreviewError }}
                        </div>
                        <div v-else-if="!requiredAttachmentsPreviewRows.length" class="small text-muted py-2 px-2">
                            Обязательные документы не настроены
                        </div>
                        <div v-else class="request-short-required-attachments-list">
                            <div
                                v-for="rule in requiredAttachmentsPreviewRows"
                                :key="rule.key"
                                class="request-short-required-attachment-row"
                            >
                                <div class="request-short-required-attachment-row__head">
                                    <div class="request-short-required-attachment-row__title">
                                        <i class="fas fa-clipboard-check text-muted mr-1"></i>
                                        <strong>{{ rule.label }}</strong>
                                    </div>
                                    <b-badge :variant="rule.files.length >= rule.minCount ? 'success' : 'warning'">
                                        {{ rule.files.length }}/{{ rule.minCount }}
                                    </b-badge>
                                </div>

                                <div v-if="rule.files.length" class="request-short-required-attachment-files">
                                    <a
                                        v-for="file in rule.files"
                                        :key="file.id"
                                        :href="getRequiredAttachmentFileUrl(file)"
                                        target="_blank"
                                        rel="noopener"
                                        class="request-short-required-attachment-file"
                                        :title="file.file_name"
                                        @click.stop.prevent="openRequiredAttachmentFile(rule, file)"
                                    >
                                        <i class="fas mr-1" :class="getRequiredAttachmentFileIcon(file)"></i>
                                        <span class="request-short-required-attachment-file__name">
                                            {{ file.file_name }}
                                        </span>
                                        <small class="text-muted ml-1">{{ formatFileSize(file.file_size) }}</small>
                                    </a>
                                </div>
                                <div v-else class="small text-muted">
                                    Файлы не приложены
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </div>
        </b-card>
    </div>
</template>

<script>
import EmployeeLink from '@/components/EmployeeLink.vue';
import {ppeText} from '@/utils/requestPpe';
import getRequestBadges from '@/utils/requestBadges';
import RequestBadge from '../components/RequestBadge.vue';
import { formatDuration } from '@/utils/requestCard/formatters';
import { getRequestNewCommentsCount, isRequestOpened } from '@/utils/requestViewedStorage';
import { CARD_BORDER_VARIANTS } from '@/constants/requestCardColors';
import { normalizeRequestTypeIcon, REQUEST_TYPE_ICON_OPTIONS } from '@/constants/requestTypeIcons';
import requestsApi from '@/store/Requests/api';
import linkifyText from '@/utils/Urlify';
import TelegramUserLink from '../RequestCard/components/TelegramUserLink.vue';
import {
    fileIconClass as getViewerFileIconClass,
    formatFileSize as formatViewerFileSize,
    isImageFile as isViewerImageFile,
    withQueryParams
} from '@/utils/fileViewer';

const CUSTOM_FIELDS_SUMMARY_SEPARATOR = ' · ';
const CUSTOM_FIELDS_SUMMARY_FIELDS_MOBILE = 4;
const CUSTOM_FIELDS_SUMMARY_FIELDS_DESKTOP = 6;
const CUSTOM_FIELDS_SUMMARY_LENGTH_MOBILE = 140;
const CUSTOM_FIELDS_SUMMARY_LENGTH_DESKTOP = 220;

export default {
    name: "RequestShortItem",
    components: {
        EmployeeLink,
        RequestBadge,
        TelegramUserLink
    },
    props: {
        request: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            detailsOpen: false,
            descExpanded: false,
            itemsPreviewOpen: false,
            itemsPreviewLoading: false,
            itemsPreviewLoaded: false,
            itemsPreviewError: '',
            itemsPreviewItems: [],
            requiredAttachmentsPreviewOpen: false,
            requiredAttachmentsPreviewLoading: false,
            requiredAttachmentsPreviewLoaded: false,
            requiredAttachmentsPreviewError: '',
            requiredAttachmentsPreviewRules: []
        };
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        isEmployeeCatalogRequest() {
            if (this.request.item_catalog_type === 'employees') {
                return true;
            }

            const workflowConfig = this.request.RequestType && this.request.RequestType.workflow_config
                ? this.request.RequestType.workflow_config
                : {};
            const itemCatalog = workflowConfig && workflowConfig.itemCatalog ? workflowConfig.itemCatalog : null;
            return Boolean(itemCatalog && itemCatalog.enabled && itemCatalog.type === 'employees');
        },
        employeeListText() {
            const names = Array.isArray(this.request.employee_names) ? this.request.employee_names.filter(Boolean) : [];
            if (names.length === 0) {
                return 'Сотрудники не выбраны';
            }

            return names.join(', ');
        },
        requestDescriptionText() {
            return String(this.request.description || '').trim();
        },
        hasRequestDescription() {
            return this.requestDescriptionText.length > 0;
        },
        customFieldDefinitions() {
            const requestType = this.request && this.request.RequestType ? this.request.RequestType : {};
            const fields = this.parseJsonValue(requestType.custom_fields, []);
            if (!Array.isArray(fields)) {
                return [];
            }

            return fields
                .filter(field => field && typeof field === 'object')
                .map(field => ({
                    ...field,
                    key: String(field.key || '').trim(),
                    label: String(field.label || field.key || '').trim(),
                    type: String(field.type || 'text').trim()
                }))
                .filter(field => field.key && field.label);
        },
        customFieldValues() {
            const workflowData = this.parseJsonValue(this.request && this.request.workflow_data, {});
            const workflowValues = workflowData && typeof workflowData === 'object' && !Array.isArray(workflowData)
                ? (workflowData.custom_fields || workflowData.customFields)
                : null;
            const values = this.parseJsonValue(workflowValues, null);

            if (values && typeof values === 'object' && !Array.isArray(values)) {
                return values;
            }

            const requestValues = this.parseJsonValue(
                this.request && (this.request.custom_fields || this.request.customFields),
                {}
            );

            return requestValues && typeof requestValues === 'object' && !Array.isArray(requestValues)
                ? requestValues
                : {};
        },
        customFieldsSummary() {
            return this.buildCustomFieldsSummary({
                maxFields: this.isMobile ? CUSTOM_FIELDS_SUMMARY_FIELDS_MOBILE : CUSTOM_FIELDS_SUMMARY_FIELDS_DESKTOP,
                maxLength: this.isMobile ? CUSTOM_FIELDS_SUMMARY_LENGTH_MOBILE : CUSTOM_FIELDS_SUMMARY_LENGTH_DESKTOP
            });
        },
        descriptionToggleText() {
            if (this.isEmployeeCatalogRequest) {
                return this.employeeListText;
            }
            return this.hasRequestDescription ? this.requestDescriptionText : this.customFieldsSummary;
        },
        requestTitle() {
            return String(this.request.title || '').trim();
        },
        requestBadges() {
            return getRequestBadges(this.request, this.$moment, {
                isNew: Boolean(this.currentUser && this.request && !isRequestOpened(this.request.id, this.currentUser))
            });
        },
        stageLifecycle() {
            return this.request && this.request.stage_lifecycle ? this.request.stage_lifecycle : null;
        },
        currentStage() {
            return this.stageLifecycle && this.stageLifecycle.current_stage
                ? this.stageLifecycle.current_stage
                : null;
        },
        stageDurationText() {
            if (!this.stageLifecycle || !this.currentStage) {
                return '';
            }

            if (this.currentStage.is_current && this.currentStage.duration_text) {
                if (this.currentStage.kind === 'approval') {
                    const label = this.currentStage.display_label || 'Согласование';
                    const automatic = this.currentStage.approval && this.currentStage.approval.automatic
                        ? ' · автоматически'
                        : '';
                    return `${label}${automatic} · ${this.currentStage.duration_text}`;
                }
                return `В статусе: ${this.currentStage.duration_text}`;
            }

            if (this.stageLifecycle.total_duration_text) {
                return `Жизненный цикл: ${this.stageLifecycle.total_duration_text}`;
            }

            return '';
        },
        stageDurationTitle() {
            if (!this.currentStage) {
                return '';
            }

            const label = this.currentStage.display_label || this.currentStage.label || this.currentStage.status;
            if (this.currentStage.is_current) {
                if (this.currentStage.kind === 'approval' && this.currentStage.approval) {
                    const progress = this.currentStage.approval.progress_text
                        ? ` (${this.currentStage.approval.progress_text.toLowerCase()})`
                        : '';
                    return `Текущий этап: ${label}${progress}`;
                }
                return `Текущий этап: ${label}`;
            }
            return `Финальный этап: ${label}`;
        },
        commentsCount() {
            const count = Number(this.request.comments_count);
            return Number.isFinite(count) ? Math.max(0, count) : 0;
        },
        newCommentsCount() {
            return getRequestNewCommentsCount(this.request, this.currentUser);
        },
        hasComments() {
            return this.commentsCount > 0;
        },
        commentsCountText() {
            return `${this.commentsCount} ${this.pluralizeComments(this.commentsCount)}`;
        },
        newCommentsCountText() {
            return `${this.newCommentsCount} ${this.pluralizeNewComments(this.newCommentsCount)}`;
        },
        commentIndicatorClass() {
            return this.newCommentsCount > 0
                ? 'request-comment-indicator--new'
                : 'request-comment-indicator--muted';
        },
        commentIndicatorTitle() {
            const parts = [`Комментарии: ${this.commentsCount}`];
            if (this.newCommentsCount > 0) {
                parts.push(`Новых: ${this.newCommentsCount}`);
            }
            if (this.request.last_comment_at) {
                parts.push(`Последний: ${this.formatDate(this.request.last_comment_at)}`);
            }
            return parts.join('. ');
        },
        cardBorderVariant() {
            const workflowConfig = this.request.RequestType && this.request.RequestType.workflow_config
                ? this.request.RequestType.workflow_config
                : {};
            const variant = workflowConfig && workflowConfig.cardBorderVariant
                ? String(workflowConfig.cardBorderVariant).trim()
                : 'primary';

            return CARD_BORDER_VARIANTS.includes(variant) ? variant : 'primary';
        },
        cardBorderVariantClass() {
            return `bg-${this.cardBorderVariant}`;
        },
        requestTypeWorkflowConfig() {
            return this.request.RequestType && this.request.RequestType.workflow_config
                ? this.request.RequestType.workflow_config
                : {};
        },
        requestTypeIcon() {
            return normalizeRequestTypeIcon(this.requestTypeWorkflowConfig.requestTypeIcon);
        },
        requestTypeIconTitle() {
            const icon = this.requestTypeIcon;
            const option = REQUEST_TYPE_ICON_OPTIONS.find(({ value }) => value === icon);
            return option ? option.text : 'Иконка типа заявки';
        },
        createdElapsedText() {
            const createdAt = this.parseDate(this.request.created_at || this.request.createdAt);
            if (!createdAt) {
                return '';
            }

            return `прошло ${formatDuration(Date.now() - createdAt.getTime())}`;
        },
        deadlineRelativeText() {
            const deadline = this.parseDate(this.request.deadline);
            if (!deadline) {
                return '';
            }

            const diff = deadline.getTime() - Date.now();
            if (Math.abs(diff) < 60000) {
                return 'срок сейчас';
            }

            return diff >= 0
                ? `осталось ${formatDuration(diff)}`
                : `просрочено на ${formatDuration(Math.abs(diff))}`;
        },
        itemsPreviewEnabled() {
            const config = this.requestTypeWorkflowConfig || {};
            const previewConfig = config.listItemsPreview || config.list_items_preview || {};
            return this.request.items_preview_enabled === true ||
                previewConfig.enabled === true ||
                config.showItemsInList === true ||
                config.show_items_in_list === true;
        },
        requiredAttachmentsPreviewEnabled() {
            const config = this.requestTypeWorkflowConfig || {};
            const requiredAttachmentsConfig = config.requiredAttachments || config.required_attachments || {};
            const previewConfig = requiredAttachmentsConfig.listPreview ||
                requiredAttachmentsConfig.list_preview ||
                {};
            const hasRules = Array.isArray(requiredAttachmentsConfig.rules) &&
                requiredAttachmentsConfig.rules.length > 0;

            return this.request.required_attachments_preview_enabled === true ||
                (
                    requiredAttachmentsConfig.enabled === true &&
                    hasRules &&
                    (
                        previewConfig.enabled === true ||
                        requiredAttachmentsConfig.showInList === true ||
                        requiredAttachmentsConfig.show_in_list === true
                    )
                );
        },
        itemsPreviewFields() {
            const fields = [
                { key: 'index', label: '№', thStyle: { width: '48px' } },
                { key: 'item_name', label: 'Позиция', thClass: 'request-short-items-table__name-col' },
                { key: 'quantity_text', label: 'Кол-во', thStyle: { width: '110px' } },
                { key: 'progress_text', label: 'Отгружено / принято', thStyle: { width: '150px' } }
            ];

            if (this.itemsPreviewRows.some(item => item.executor_text !== '-')) {
                fields.push({ key: 'executor_text', label: 'Исполнитель', thStyle: { width: '170px' } });
            }

            return fields;
        },
        itemsPreviewRows() {
            return this.itemsPreviewItems.map((item, index) => ({
                ...item,
                index: index + 1,
                quantity_text: this.formatItemQuantity(item),
                progress_text: this.formatItemProgress(item),
                executor_text: this.formatExecutor(item.executor)
            }));
        },
        requiredAttachmentsPreviewRows() {
            return this.requiredAttachmentsPreviewRules.map(rule => ({
                ...rule,
                minCount: Math.max(1, Number(rule.minCount || rule.min_count || 1)),
                files: Array.isArray(rule.files) ? rule.files : []
            }));
        }
    },
    watch: {
        'request.id'() {
            this.itemsPreviewOpen = false;
            this.itemsPreviewLoading = false;
            this.itemsPreviewLoaded = false;
            this.itemsPreviewError = '';
            this.itemsPreviewItems = [];
            this.requiredAttachmentsPreviewOpen = false;
            this.requiredAttachmentsPreviewLoading = false;
            this.requiredAttachmentsPreviewLoaded = false;
            this.requiredAttachmentsPreviewError = '';
            this.requiredAttachmentsPreviewRules = [];
        }
    },
    methods: {
        ppeText,
        parseJsonValue(value, fallback) {
            if (value === undefined || value === null || value === '') {
                return fallback;
            }
            if (typeof value === 'string') {
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return fallback;
                }
            }
            return value;
        },
        formatLinkedText(text) {
            return linkifyText(text);
        },
        parseDate(value) {
            if (!value) {
                return null;
            }

            const date = new Date(value);
            return Number.isNaN(date.getTime()) ? null : date;
        },
        isEmptyCustomFieldValue(value) {
            if (value === undefined || value === null) return true;
            if (typeof value === 'string') return value.trim() === '';
            if (Array.isArray(value)) return value.length === 0;
            if (typeof value === 'object') {
                if (
                    Object.prototype.hasOwnProperty.call(value, 'from') ||
                    Object.prototype.hasOwnProperty.call(value, 'to') ||
                    Object.prototype.hasOwnProperty.call(value, 'start') ||
                    Object.prototype.hasOwnProperty.call(value, 'end') ||
                    Object.prototype.hasOwnProperty.call(value, 'date_from') ||
                    Object.prototype.hasOwnProperty.call(value, 'date_to')
                ) {
                    return ![
                        value.from,
                        value.to,
                        value.start,
                        value.end,
                        value.date_from,
                        value.date_to,
                        value.dateFrom,
                        value.dateTo
                    ].some(item => item !== undefined && item !== null && String(item).trim() !== '');
                }
                return Object.keys(value).length === 0;
            }
            return false;
        },
        formatCustomFieldLabel(field) {
            return String((field && (field.label || field.key)) || '').replace(/[:：]\s*$/, '').trim();
        },
        normalizeBoolean(value) {
            if (value === true || value === false) {
                return value;
            }
            if (typeof value === 'string') {
                const normalized = value.trim().toLowerCase();
                return ['true', '1', 'yes', 'да'].indexOf(normalized) !== -1;
            }
            return Boolean(value);
        },
        getObjectLabel(value) {
            if (!value || typeof value !== 'object' || Array.isArray(value)) {
                return '';
            }

            const label = [
                value.label,
                value.text,
                value.name,
                value.full_name,
                value.title,
                value.value,
                value.id
            ].find(item => item !== undefined && item !== null && String(item).trim() !== '');

            return label === undefined ? '' : String(label).trim();
        },
        getRangeBoundaryValue(value, keys) {
            if (!value || typeof value !== 'object' || Array.isArray(value)) {
                return undefined;
            }
            for (let i = 0; i < keys.length; i += 1) {
                if (value[keys[i]] !== undefined) {
                    return value[keys[i]];
                }
            }
            return undefined;
        },
        formatCustomFieldDate(value, includeTime) {
            if (this.isEmptyCustomFieldValue(value)) {
                return '';
            }

            const text = String(value).trim();
            const match = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/);
            if (match) {
                const datePart = `${match[3]}.${match[2]}.${match[1]}`;
                return includeTime && match[4] && match[5]
                    ? `${datePart} ${match[4]}:${match[5]}`
                    : datePart;
            }

            const date = new Date(text);
            if (Number.isNaN(date.getTime())) {
                return text;
            }

            const datePart = date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            if (!includeTime) {
                return datePart;
            }

            const timePart = date.toLocaleTimeString('ru-RU', {
                hour: '2-digit',
                minute: '2-digit'
            });
            return `${datePart} ${timePart}`;
        },
        formatCustomFieldRange(value, includeTime) {
            const parsed = this.parseJsonValue(value, value);
            let from;
            let to;

            if (Array.isArray(parsed)) {
                from = parsed[0];
                to = parsed[1];
            } else if (parsed && typeof parsed === 'object') {
                from = this.getRangeBoundaryValue(parsed, ['from', 'start', 'date_from', 'dateFrom']);
                to = this.getRangeBoundaryValue(parsed, ['to', 'end', 'date_to', 'dateTo']);
            }

            const fromText = this.formatCustomFieldDate(from, includeTime);
            const toText = this.formatCustomFieldDate(to, includeTime);

            if (fromText && toText) {
                return `с ${fromText} по ${toText}`;
            }
            if (fromText) {
                return `с ${fromText}`;
            }
            if (toText) {
                return `по ${toText}`;
            }
            return '';
        },
        formatCustomFieldLooseValue(value, depth = 0) {
            const parsed = this.parseJsonValue(value, value);
            if (this.isEmptyCustomFieldValue(parsed)) {
                return '';
            }

            if (Array.isArray(parsed)) {
                const parts = parsed
                    .map(item => this.formatCustomFieldLooseValue(item, depth + 1))
                    .filter(Boolean);
                const visibleParts = parts.slice(0, 5);
                const suffix = parts.length > visibleParts.length
                    ? `, еще ${parts.length - visibleParts.length}`
                    : '';
                return `${visibleParts.join(', ')}${suffix}`;
            }

            if (parsed && typeof parsed === 'object') {
                const label = this.getObjectLabel(parsed);
                if (label) {
                    return label;
                }
                if (depth === 0) {
                    return this.formatCustomFieldRange(parsed, false);
                }
                return '';
            }

            return String(parsed).trim();
        },
        formatCustomFieldValue(field, value) {
            const type = field && field.type ? field.type : 'text';

            if (type === 'checkbox') {
                return this.normalizeBoolean(value) ? 'Да' : '';
            }
            if (this.isEmptyCustomFieldValue(value)) {
                return '';
            }

            switch (type) {
                case 'number':
                    return this.formatNumber(value);
                case 'date':
                    return this.formatCustomFieldDate(value, false);
                case 'datetime':
                    return this.formatCustomFieldDate(value, true);
                case 'date_range':
                    return this.formatCustomFieldRange(value, false);
                case 'datetime_range':
                    return this.formatCustomFieldRange(value, true);
                default:
                    return this.formatCustomFieldLooseValue(value);
            }
        },
        buildCustomFieldsSummary({ maxFields, maxLength }) {
            const values = this.customFieldValues;
            const entries = this.customFieldDefinitions
                .map(field => {
                    const value = Object.prototype.hasOwnProperty.call(values, field.key)
                        ? values[field.key]
                        : undefined;
                    const formattedValue = this.formatCustomFieldValue(field, value);
                    const label = this.formatCustomFieldLabel(field);

                    return formattedValue && label ? `${label}: ${formattedValue}` : '';
                })
                .filter(Boolean);

            if (!entries.length) {
                return '';
            }

            const limit = Math.max(1, Number(maxFields) || entries.length);
            const parts = entries.slice(0, limit);
            const hasMore = entries.length > parts.length;
            let summary = parts.join(CUSTOM_FIELDS_SUMMARY_SEPARATOR);

            if (hasMore) {
                summary = `${summary}...`;
            }

            const lengthLimit = Math.max(0, Number(maxLength) || 0);
            if (lengthLimit > 0 && summary.length > lengthLimit) {
                const trimmed = summary
                    .slice(0, Math.max(0, lengthLimit - 3))
                    .replace(/\s+\S*$/, '')
                    .trim();
                summary = `${trimmed || summary.slice(0, Math.max(0, lengthLimit - 3)).trim()}...`;
            }

            return summary;
        },
        formatNumber(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }

            const numberValue = Number(value);
            if (Number.isNaN(numberValue)) {
                return String(value);
            }

            return numberValue.toLocaleString('ru-RU', {
                maximumFractionDigits: 3
            });
        },
        formatItemQuantity(item) {
            const quantity = this.formatNumber(item.quantity);
            const unit = item.unit ? String(item.unit).trim() : '';

            if (!quantity && !unit) {
                return '-';
            }

            return [quantity, unit].filter(Boolean).join(' ');
        },
        formatItemProgress(item) {
            const shipped = this.formatNumber(item.shipped_quantity);
            const accepted = this.formatNumber(item.accepted_quantity);

            if (!shipped && !accepted) {
                return '-';
            }

            return `${shipped || '0'} / ${accepted || '0'}`;
        },
        formatExecutor(executor) {
            if (!executor) {
                return '-';
            }

            return [executor.last_name, executor.first_name].filter(Boolean).join(' ') || '-';
        },
        formatFileSize(size) {
            return formatViewerFileSize(size);
        },
        async loadItemsPreview() {
            if (this.itemsPreviewLoaded || this.itemsPreviewLoading) {
                return;
            }

            this.itemsPreviewLoading = true;
            this.itemsPreviewError = '';

            try {
                const data = await requestsApi.getRequestItemsPreview(this.request.id);
                this.itemsPreviewItems = data && Array.isArray(data.items) ? data.items : [];
                this.itemsPreviewLoaded = true;
            } catch (e) {
                console.error('Ошибка загрузки позиций заявки:', e);
                this.itemsPreviewError = 'Не удалось загрузить позиции';
            } finally {
                this.itemsPreviewLoading = false;
                this.$nextTick(() => this.$emit('layoutChanged'));
            }
        },
        async loadRequiredAttachmentsPreview() {
            if (this.requiredAttachmentsPreviewLoaded || this.requiredAttachmentsPreviewLoading) {
                return;
            }

            this.requiredAttachmentsPreviewLoading = true;
            this.requiredAttachmentsPreviewError = '';

            try {
                const data = await requestsApi.getRequestRequiredAttachmentsPreview(this.request.id);
                this.requiredAttachmentsPreviewRules = data && Array.isArray(data.rules) ? data.rules : [];
                this.requiredAttachmentsPreviewLoaded = true;
            } catch (e) {
                console.error('Ошибка загрузки обязательных документов заявки:', e);
                this.requiredAttachmentsPreviewError = 'Не удалось загрузить документы';
            } finally {
                this.requiredAttachmentsPreviewLoading = false;
                this.$nextTick(() => this.$emit('layoutChanged'));
            }
        },
        async toggleItemsPreview() {
            this.itemsPreviewOpen = !this.itemsPreviewOpen;
            this.$nextTick(() => this.$emit('layoutChanged'));

            if (this.itemsPreviewOpen) {
                await this.loadItemsPreview();
            }
        },
        async toggleRequiredAttachmentsPreview() {
            this.requiredAttachmentsPreviewOpen = !this.requiredAttachmentsPreviewOpen;
            this.$nextTick(() => this.$emit('layoutChanged'));

            if (this.requiredAttachmentsPreviewOpen) {
                await this.loadRequiredAttachmentsPreview();
            }
        },
        getRequiredAttachmentFileUrl(file) {
            const requestId = this.request && this.request.id;
            if (!requestId || !file || !file.id) {
                return '#';
            }

            const token = this.$store.state.token;
            const url = `/api/requests/items/${requestId}/files/${file.id}`;
            return token ? withQueryParams(url, {gjuid: token}) : url;
        },
        getRequiredAttachmentFileIcon(file) {
            return getViewerFileIconClass(file).replace(/^fas\s+/, '');
        },
        getRequiredAttachmentViewerFiles(rule) {
            if (!rule || !Array.isArray(rule.files)) {
                return [];
            }
            return rule.files.map(file => {
                const url = this.getRequiredAttachmentFileUrl(file);
                const image = isViewerImageFile(file);
                return {
                    id: file.id,
                    name: file.file_name || file.originalName || `Файл`,
                    url,
                    downloadUrl: url,
                    thumbnailUrl: image ? withQueryParams(url, {thumb: 1, w: 128, h: 96}) : null,
                    mimeType: file.mime_type || file.mimeType,
                    size: file.file_size || file.size,
                    isImage: image,
                    raw: file
                };
            });
        },
        openRequiredAttachmentFile(rule, file) {
            const files = this.getRequiredAttachmentViewerFiles(rule);
            if (!files.length || !file) {
                return;
            }
            if (!this.$fileViewer) {
                window.open(this.getRequiredAttachmentFileUrl(file), `_blank`);
                return;
            }
            this.$fileViewer.open(files, {
                startId: file.id,
                source: `request-required-attachments`
            });
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const datePart = date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
            const weekday = date.toLocaleDateString('ru-RU', { weekday: 'short' }).replace('.', '');
            const timePart = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
            return `${datePart} ${weekday}, ${timePart}`;
        },
        async viewDetails() {
            try {
                sessionStorage.setItem('requestsListReturn', JSON.stringify({
                    requestId: this.request.id,
                    tab: this.$store.state.requests.selectedTab,
                    page: this.$store.state.requests.listPage,
                    savedAt: Date.now()
                }));
            } catch (e) { /* sessionStorage недоступен */ }
            // Помечаем текущую запись history highlight-ом, чтобы browser back/phone back
            // возвращали в /requests?highlight=<id> и запускали восстановление списка.
            if (this.$route.path === '/requests') {
                const currentHighlight = this.$route.query && this.$route.query.highlight;
                if (String(currentHighlight || '') !== String(this.request.id)) {
                    const nextQuery = { ...this.$route.query, highlight: String(this.request.id) };
                    await this.$router.replace({
                        path: this.$route.path,
                        query: nextQuery
                    }).catch(() => {});
                }
            }
            this.$router.push(`/requests/${this.request.id}`);
        },
        handleCopy() {
            this.$router.push({
                path: '/requests/create',
                query: { copyFrom: this.request.id }
            });
        },
        pluralizeComments(count) {
            const normalized = Math.abs(Number(count)) % 100;
            const lastDigit = normalized % 10;

            if (normalized > 10 && normalized < 20) {
                return 'комментариев';
            }
            if (lastDigit === 1) {
                return 'комментарий';
            }
            if (lastDigit >= 2 && lastDigit <= 4) {
                return 'комментария';
            }
            return 'комментариев';
        },
        pluralizeNewComments(count) {
            const normalized = Math.abs(Number(count)) % 100;
            const lastDigit = normalized % 10;

            if (normalized > 10 && normalized < 20) {
                return 'новых';
            }
            if (lastDigit === 1) {
                return 'новый';
            }
            return 'новых';
        }
    }
}
</script>

<style scoped>
.request-short-card {
    position: relative;
    overflow: hidden;
}

.request-short-card__accent {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 4px;
    z-index: 1;
}

.request-short-inline-icon {
    width: 1rem;
    margin: 0 0.25rem;
    color: #6c757d;
    font-size: 0.85rem;
    text-align: center;
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.small {
    font-size: 0.875rem;
}

.details-toggle,
.desc-toggle {
    text-decoration: none;
    font-size: .8rem;
}

.details-toggle:hover,
.desc-toggle:hover {
    text-decoration: underline;
}

.request-short-actions {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.35rem;
    flex-wrap: wrap;
}

.request-short-icon-button {
    width: 32px;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.request-comment-indicator {
    background: transparent;
    border: 0;
    color: #495057;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.78rem;
    line-height: 1.25;
    padding: 0;
    text-align: left;
}

.request-comment-indicator:hover,
.request-comment-indicator:focus {
    color: #0056b3;
    text-decoration: underline;
}

.request-comment-indicator:focus {
    outline: none;
}

.request-comment-indicator--new {
    color: #0056b3;
    font-weight: 600;
}

.request-comment-indicator__new {
    color: #0056b3;
    font-weight: 700;
}

.request-comment-indicator__separator {
    color: #6c757d;
    font-weight: 400;
    margin: 0 0.15rem;
}

.request-comment-row {
    margin-top: 0.25rem;
}

.request-stage-duration {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    margin-top: 0.25rem;
    color: #495057;
    font-size: 0.78rem;
    line-height: 1.25;
}

.request-stage-duration i {
    color: #6c757d;
}

.request-short-relative {
    color: #6c757d;
    font-weight: 400;
}

.request-short-items-preview {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background: #ffffff;
    overflow: hidden;
}

.request-short-required-attachments-preview {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background: #ffffff;
    overflow: hidden;
}

.request-short-required-attachments-list {
    display: flex;
    flex-direction: column;
}

.request-short-required-attachment-row {
    padding: 0.55rem 0.75rem;
    border-bottom: 1px solid #edf0f2;
}

.request-short-required-attachment-row:last-child {
    border-bottom: 0;
}

.request-short-required-attachment-row__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.35rem;
}

.request-short-required-attachment-row__title {
    min-width: 0;
}

.request-short-required-attachment-files {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
}

.request-short-required-attachment-file {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    padding: 0.2rem 0.45rem;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background: #f8f9fa;
    color: #495057;
    font-size: 0.8rem;
    line-height: 1.25;
}

.request-short-required-attachment-file:hover,
.request-short-required-attachment-file:focus {
    border-color: #007bff;
    color: #0056b3;
    text-decoration: none;
}

.request-short-required-attachment-file__name {
    min-width: 0;
    max-width: 16rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.request-short-items-table {
    font-size: 0.82rem;
}

.request-short-items-table__name {
    width: 18rem;
    max-width: 18rem;
    min-width: 14rem;
}

.request-short-items-table__notes {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.request-short-description-text {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.request-short-description-text--custom-fields {
    color: #495057;
}

.request-short-items-table :deep(.request-short-items-table__head th) {
    border-top: 0;
    color: #6c757d;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

.request-short-items-table :deep(td) {
    vertical-align: top;
}

.request-short-items-table :deep(tbody tr:nth-child(odd) > td) {
    background-color: #ffffff;
}

.request-short-items-table :deep(tbody tr:nth-child(even) > td) {
    background-color: #f8f9fa;
}

.request-short-items-table :deep(tbody tr:hover > td) {
    background-color: #eef4ff;
}

/* Обрезать описание до 2 строк на мобиле */
.description-clamped p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

@media (max-width: 767.98px) {
    .copy-desktop { display: none !important; }

    /* Уменьшить отступы внутри карточки */
    .card .card-body {
        padding: .5rem .75rem;
    }
    .card .card-body .card-body-content {
        /* обёртка для контентной зоны */
    }

    .request-short-actions {
        width: 100%;
        justify-content: flex-end;
        margin-top: .35rem;
    }

    .request-short-items-table__name {
        min-width: 10rem;
        width: auto;
        max-width: none;
    }
}

@media (min-width: 768px) {
    .request-short-items-table {
        width: auto;
        min-width: 42rem;
        max-width: 100%;
    }

    .request-short-items-table :deep(.request-short-items-table__name-col) {
        width: 18rem;
    }
}

@media (min-width: 768px) {
    .copy-mobile { display: none !important; }
    .details-toggle { display: none !important; }
    .desc-toggle { display: none !important; }
    .description-clamped p {
        /* на десктопе не обрезаем */
        display: block;
        -webkit-line-clamp: unset;
        overflow: visible;
    }
}
</style>
